import '../components/InputBox.css'
import { useState, useEffect} from 'react'
import MichiganGeojson from '../data/MichiganGeojson.json'

export default function InputBox({ submitInput }) {
  const [input, setInput] = useState('');
  const sampleData = JSON.stringify(MichiganGeojson);

  function handleInput(event) {
    const inputValue = event.target.value;
    setInput(inputValue);
  }

  useEffect(() => {
    setInput(sampleData);
  },[sampleData]);

  return (
    <>
      <div className="d-flex justify-content-center">
        <div className="input-group">
          <div className="input-group-prepend">
            <span className="input-group-text">GEO JSON</span>
          </div>
          <textarea
            
            className="form-control"
            aria-label="With textarea"
            onInput={(event) => handleInput(event)}
          >
            {sampleData}
          </textarea>
        </div>
      </div>

      <div className="d-flex  justify-content-center">
        <div className="p-2">
          <button
            type="button"
            className="btn btn-success float-left"
            onClick={() => submitInput(input)}
          >
            Submit
          </button>
        </div>
      </div>
    </>
  )
}
